var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-timeline-strip"},[(_vm.chartParams)?_c('dp-chart',{staticStyle:{"height":"60px"},attrs:{"chart-params":_vm.chartParams,"margins":{ l: 0, b: 30, r: 0, t: 0 }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }